/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrColumnGroupDescription } from './igr-column-group-description';
import { ColumnGroupDescription } from './ColumnGroupDescription';
import { TypeRegistrar } from "igniteui-react-core";
var IgrColumnGroupDescriptionModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnGroupDescriptionModule() {
    }
    IgrColumnGroupDescriptionModule.register = function () {
        TypeRegistrar.registerCons("IgrColumnGroupDescription", IgrColumnGroupDescription);
        TypeRegistrar.register("ColumnGroupDescription", ColumnGroupDescription.$type);
    };
    return IgrColumnGroupDescriptionModule;
}());
export { IgrColumnGroupDescriptionModule };
//# sourceMappingURL=igr-column-group-description-module.js.map
